// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"88c76639","855":"ff0a9136","972":"05b9ba44"}[chunkId] + ".chunk.js";
};